import { css } from 'lit';

export default css`
  :host {
    display: inline-block;
    color: var(--webmodule-color-neutral-600);
  }

  .icon-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    border-radius: var(--webmodule-border-radius-medium);
    font-size: inherit;
    color: inherit;
    padding: var(--webmodule-spacing-x-small);
    cursor: pointer;
    transition: var(--webmodule-animate-x-fast) color;
    -webkit-appearance: none;
  }

  .icon-button:hover:not(.icon-button--disabled),
  .icon-button:focus-visible:not(.icon-button--disabled) {
    color: var(--webmodule-color-primary);
  }

  .icon-button:active:not(.icon-button--disabled) {
    color: var(--webmodule-color-primary-700);
  }

  .icon-button:focus {
    outline: none;
  }

  .icon-button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon-button:focus-visible {
    outline: var(--webmodule-focus-border);
    outline-offset: var(--webmodule-focus-border-offset);
  }

  .icon-button__icon {
    pointer-events: none;
  }
`;
